import BookingReward from '@design/objects/booking-reward/twig/assets/index'
import Tooltip from '@design/objects/tooltip/twig/assets/index'

export default function (element: HTMLElement): () => void {
  const destroyTooltips = Tooltip(element.querySelectorAll<HTMLElement>('.c-price-display-old-price__discount-info[data-tooltip-id]'))

  const rewardEl = element.querySelector<HTMLElement>('.o-booking-reward')
  const bookingReward = rewardEl ? new BookingReward(rewardEl) : null

  return () => {
    destroyTooltips()
    bookingReward?.destroy()
  }
}
